var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoinShareOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0428 23.6257C31.3826 23.6257 35.7114 19.297 35.7114 13.9571C35.7114 8.61734 31.3826 4.28857 26.0428 4.28857C20.703 4.28857 16.3743 8.61734 16.3743 13.9571C16.3743 19.297 20.703 23.6257 26.0428 23.6257Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0428 16.3743V11.54",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28857 29.6686L10.1954 34.5909C11.0642 35.315 12.1593 35.7114 13.2903 35.7114H28.8629C29.9753 35.7114 30.8771 34.8096 30.8771 33.6972C30.8771 31.4723 29.0735 29.6686 26.8486 29.6686H16.0221",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.54 27.2514L13.3529 29.0643C14.3541 30.0655 15.9774 30.0655 16.9786 29.0643C17.9798 28.0631 17.9798 26.4398 16.9786 25.4386L14.1645 22.6245C13.2579 21.7179 12.0283 21.2086 10.7461 21.2086H4.28857",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoinShareOutline);
export default __webpack_public_path__ + "static/media/icon_coin_share_outline.58adac17855db6db8b1581f916421ca5.svg";
export { ForwardRef as ReactComponent };